import { Post } from "@forcode/domain";
import { Divider, Image } from "../../atom";
import { PostHeader } from "../../organism";
import css from "./PostTemplate.module.css";

export interface PostTemplateProps {
  children: JSX.Element | JSX.Element[];
  post: Post;
}

const BASE_CLASS = "f-PostTemplate";

export const PostTemplate = ({ post, children }: PostTemplateProps) => {
  return (
    <section className={css[BASE_CLASS]}>
      <article className={css[`${BASE_CLASS}-content`]}>
        <>
          <PostHeader post={post} />
          <Image
            alt={post.title}
            src={post.image.src}
            provider={post.image.provider}
            className={css[`${BASE_CLASS}-picture`]}
            width={859}
            height={318}
            loading="eager"
          />
          <Divider />
          {children}
        </>
      </article>
    </section>
  );
};
